<template>
    <span>
        <h2 class="text-center mt-6">Добавить мастеров в свою смену:</h2>
        <div cols="12" class="row justify-content-center">
            <div
                v-for="(availableEmployee, indx) in sortedEmployees"
                class="px-2 pt-4"
                style="position: relative"
                :key="'semp-' + indx"
            >
                <input
                    type="checkbox"
                    :id="'emp-' + availableEmployee.employeeId"
                    :name="'emp-' + availableEmployee.employeeId"
                    :value="availableEmployee.employeeId"
                    v-model="employees"
                    :disabled="availableEmployee.leaved_at"
                >
                <label :for="'emp-' + availableEmployee.employeeId">
                    <div class="v-avatar v-list-item__avatar grey" style="position: absolute; margin-left: 7px; left: 3px;">
                        <i aria-hidden="true" class="v-icon notranslate mdi mdi-account-circle theme--dark" style="font-size: 80px;"></i>
                    </div>
                    <div class="btn btn-options__checkbox">
                        <!-- <img class="rounded-circle z-depth-2 w-100" :src="'https://eu.ui-avatars.com/api/?name=' + availableEmployee.name + '+' + availableEmployee.surname"/> -->
                        <!-- <br/> -->
                        <span class="d-block">{{ availableEmployee.fullName }}</span>
                        <span class="d-block pt-2 font-weight-lighter">Мастер 1 уровня</span>
                        <span class="d-block pt-2 font-weight-lighter">Выиграно мотивити: {{ availableEmployee.winned_motivations }}</span>
                    </div>
                </label>
            </div>
        </div>
    </span>
</template>

<script>
import axios from '../../../plugins/axios-common'

export default {
    name: 'addEmployees',
    props: ['value', 'userData'],
    data () {
        return {
            availableEmployees: [],
            loading: true,
        }
    },
    async mounted() {
        axios
            .get('/api/cash/workshop/availableemployees')
            .then(response => {
                this.availableEmployees = response.data.data.employees
            })
            .catch(error => {
                console.log(error)
                this.error = true
            })
            .finally(() => (
                this.loading = false
            ))
    },
    computed: {
        employees: {
            get() {
                return this.value
            },
            set(value) {
              this.$emit('input', value)
            }
        },
        sortedEmployees () {
            if (this.availableEmployees.length > 0) {
                const data = [...this.availableEmployees]
                return data.filter(item => item.employeeId !== this.userData.id)
            } else {
                return []
            }
        },
    }
}
</script>

<style scoped>
    input[type="radio"], input[type="checkbox"] {
        opacity: 0;
        position: fixed;
        width: 0;
    }
    .btn-options__checkbox {
        display: table-cell;
        padding: 10px;
        padding-left: 50px;
        width: 20vw;
        height: 6vh;
        border-radius: 15px;
        background-color: #eee;
        vertical-align: middle;
    }

    .btn-options__checkbox:hover {
        box-shadow: 0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15);
    }

    input[type="radio"]:focus + label, input[type="checkbox"]:checked  + label {
        border-radius: 15px;
    }

    input[type="radio"]:checked + label>div, input[type="checkbox"]:checked + label>div {
        background-color: #fffbcd;
        box-shadow: inset 1px 2px 4px 0 rgba(0, 0, 0, .4);
    }

    .btn-primary {
        padding: 10px 30px;
        background: linear-gradient(180deg, #C8FA92 0%, #B5E97C 50%);
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
        border-radius: 11px;
        font-size: 20px;
        color: #000;
    }
</style>
